import styled from "styled-components";
import { CSSVars } from "@/styles/styles.config";

export const StyledSection = styled.section`
  background: ${CSSVars.white};
  padding: 70px 20px;

  @media screen and (min-width: ${CSSVars.breakpointMD}) {
    padding: 90px 30px;
  }
  @media screen and (min-width: ${CSSVars.breakpointLG}) {
    padding: 110px 40px;
  }

  .inner {
    max-width: 1240px;
    margin: 0 auto;
  }

  header {
    text-align: center;
    margin-bottom: 48px;

    @media screen and (min-width: ${CSSVars.breakpointLG}) {
      margin-bottom: 64px;
    }
  }

  h2 {
    font-family: ${CSSVars.primaryFont};
    font-weight: 700;
    font-size: 30px;
    line-height: 1.15;
    letter-spacing: -0.02em;
    color: ${CSSVars.black};
    margin: 0 auto;
    max-width: 820px;

    @media screen and (min-width: ${CSSVars.breakpointMD}) {
      font-size: 40px;
    }
    @media screen and (min-width: ${CSSVars.breakpointLG}) {
      font-size: 48px;
    }
  }

  .grid {
    list-style: none;
    margin: 0;
    padding: 0;
    display: grid;
    grid-template-columns: 1fr;
    gap: 18px;

    @media screen and (min-width: ${CSSVars.breakpointMD}) {
      grid-template-columns: repeat(2, 1fr);
      gap: 24px;
    }
  }

  .card {
    background: ${CSSVars.white};
    border: 1px solid ${CSSVars.gray100};
    border-radius: 18px;
    padding: 28px;
    display: flex;
    flex-direction: column;
    gap: 14px;
    transition: box-shadow 0.25s ease, transform 0.25s ease,
      border-color 0.25s ease;
    position: relative;
    overflow: hidden;

    @media screen and (min-width: ${CSSVars.breakpointLG}) {
      padding: 36px 32px;
    }

    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 3px;
      background: linear-gradient(
        270deg,
        ${CSSVars.pink300} 0%,
        ${CSSVars.purple500} 50%,
        ${CSSVars.blue500} 100%
      );
      opacity: 0;
      transition: opacity 0.25s ease;
    }

    &:hover {
      transform: translateY(-3px);
      box-shadow: 0 16px 36px rgba(16, 24, 40, 0.08);
      border-color: ${CSSVars.gray200};

      &::before {
        opacity: 1;
      }

      .icon {
        background: linear-gradient(
          135deg,
          ${CSSVars.blue500} 0%,
          ${CSSVars.purple500} 50%,
          ${CSSVars.pink300} 100%
        );
        color: ${CSSVars.white};
        border-color: transparent;
      }
    }

    .icon {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 56px;
      height: 56px;
      border-radius: 14px;
      background: ${CSSVars.gray50};
      color: ${CSSVars.blue500};
      border: 1px solid ${CSSVars.gray100};
      transition: background 0.25s ease, color 0.25s ease,
        border-color 0.25s ease;
      flex-shrink: 0;
    }

    h3 {
      font-family: ${CSSVars.primaryFont};
      font-weight: 600;
      font-size: 19px;
      line-height: 1.3;
      color: ${CSSVars.black};
      margin: 0;
      letter-spacing: -0.01em;

      @media screen and (min-width: ${CSSVars.breakpointMD}) {
        font-size: 21px;
      }
    }

    p {
      font-family: ${CSSVars.secondaryFont};
      font-weight: 400;
      font-size: 15px;
      line-height: 1.65;
      color: #4b5563;
      margin: 0;
    }
  }
`;
